'use client'

import { cn } from '@/lib/utils'
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs'

type TagProps = {
  id: string
  name: string
}

const Tag = ({ id, name }: TagProps) => {
  const [query, setQuery] = useQueryState(
    'tags',
    parseAsArrayOf(parseAsString).withOptions({
      shallow: false,
    }),
  )

  const checked = query?.includes(id) ?? false

  return (
    <button
      className={cn(
        'border border-secondary-900 p-2 text-xs text-secondary-900 hover:bg-grey-500',
        checked && 'bg-grey-400',
      )}
      onClick={() => {
        setQuery((prev) => {
          const tags = checked
            ? (prev || []).filter((tag) => tag !== id)
            : [...(prev || []), id]
          return tags.length ? tags : null
        })
      }}
    >
      {name}
    </button>
  )
}

export default Tag
